import React, { useContext } from "react";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import { Typography, Paper } from "@material-ui/core";

import inbox from "../../../../img/inbox.svg";
import dots from "../../../../img/dots.svg";
import "./Inbox.css";
import globalContent from "../../../../locales";
import { getSelectedLanguage } from "../../../../util/helperFunctions";
import { Context } from "../../../../context/createContext";

const Inbox = () => {
  const { selectedLanguage } = useContext(Context);
  return (
    <Paper className="inbox-container">
      <div className="inbox-wrapper">
        <div style={{ display: "flex", width: "100%", marginBottom: "20px" }}>
          <img src={inbox} alt="Inbox" />
          <div style={{ alignSelf: "center", marginLeft: "6px" }}>
            <h4>{globalContent.inbox[selectedLanguage]}</h4>
            <p style={{ fontSize: "12px", marginTop: "5px" }}>
              {globalContent.item[selectedLanguage]}
            </p>
          </div>
          <img src={dots} className="inbox-more-icon" />
        </div>
        <p style={{ fontWeight: "bold" }}>
          {globalContent.cont[selectedLanguage]}
          {localStorage.getItem("company")}{" "}
          {globalContent.goal[selectedLanguage]}
        </p>
        <p>{globalContent.date[selectedLanguage]}</p>
      </div>
      <a href="#">
        <Typography color="primary">
          {globalContent.go[selectedLanguage]}
        </Typography>
      </a>
    </Paper>
  );
};

export default Inbox;
